// Pure helpers for AdminExtensions, extracted VERBATIM.

function formatDateTime(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString(undefined, {
      month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
    });
  } catch { return String(value); }
}
function initials(first, last) {
  const a = (first || '').trim()[0] || '';
  const b = (last  || '').trim()[0] || '';
  return (a + b).toUpperCase() || '·';
}
const fadeUp = (delay = 0) => ({
  initial: false, // no entrance animation: content renders in place
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.32, delay, ease: [0.22, 1, 0.36, 1] },
});

// Quizzes carry a quiz_type (quiz/midterm/final_exam) - surface that instead
// of the generic "quiz" item_type so the TYPE chip reflects what the student
// actually requested an extension for.
const QUIZ_TYPE_LABELS = { midterm: 'Midterm', final_exam: 'Final Exam' };
function formatItemType(itemType, quizType) {
  if (itemType === 'quiz' && QUIZ_TYPE_LABELS[quizType]) return QUIZ_TYPE_LABELS[quizType];
  return itemType;
}

export { formatDateTime, initials, fadeUp, formatItemType };
